import { Trans } from 'react-i18next'

import bodySecretsPNG from '~/assets/images/anatomy/body-secrets.png'
import bodySecretsWEBP from '~/assets/images/anatomy/body-secrets.webp'
import { InfoPageStyles as S } from '~/pages/anatomy/libs/infoPageStyles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const BodySecrets = ({ nextPagePath, pageId }: TPageProps) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Your body is hiding brilliant secrets',
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ImageWrapper>
          <picture>
            <source srcSet={bodySecretsWEBP} type="image/webp" />
            <img src={bodySecretsPNG} alt="Body Secrets" />
          </picture>
        </S.ImageWrapper>

        <S.Title>
          <Trans ns="anatomy" i18nKey="onboarding.bodySecrets.title" />
        </S.Title>

        <S.Subtitle>
          <Trans ns="anatomy" i18nKey="onboarding.bodySecrets.subtitle" />
        </S.Subtitle>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default BodySecrets
